<template>
  <div>
    <div class="view-area">
      <div class="info-area">
        <div class="description-area">
          <div class="folding-area">
            <p class="text">現在スタッフの募集は</p>
            <p class="text">しておりません</p>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <Menu />
  </div>
</template>

<script>
import Footer from './modules/Footer'
import Menu from './modules/Menu'

export default {
  name: 'Recruit',
  components: {
    Footer,
    Menu
  }
}
</script>

<style scoped>
.view-area {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100vh;
  width: 100%;
}
@supports (-webkit-touch-callout: none) {
  .view-area {
    /* Safari用のハック */
    height: -webkit-fill-available;
  }
}
.info-area {
  display: flex;
  justify-content: center;
  margin-left: 128px;
}
.folding-area {
  display: flex;
  flex-wrap: wrap;
}
.description-area {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: 0 24px 0 96px;
}
.text {
  font-size: 13px;
  color: #000;
  letter-spacing: 4.5px;
}
@media (max-width: 639px) {
  .view-area {
    justify-content: flex-start;
  }
  .info-area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 32px;
  }
  .folding-area {
    flex-direction: column;
  }
  .description-area {
    margin: 24px 16px 0 16px;
  }
  .text {
    font-size: 11px;
    padding-bottom: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Recruit.vue